import { openDB } from 'idb';
import v1_actionDownloadMediaWhatsapp from 'src/actions/v1/whatsapp/v1_actionDownloadMediaWhatsapp';
import { soNumeros } from 'src/utils/functions';

// Função para abrir o banco de dados
const openImageDB = async () => {
  return openDB('image-store', 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('blobs')) {
        db.createObjectStore('blobs', { keyPath: 'id' });
      }
    },
  });
};

// Função para converter Base64 para Blob
export const base64ToBlob = (base64, mimeType) => {
  const byteCharacters = atob(base64.split(',')[1]); // Ignora a parte do cabeçalho da base64
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
};

// Função para gerar uma URL Blob
export const createBlobUrl = (blob) => {
  return URL.createObjectURL(blob);
};


export async function initCacheFileSave(id, base64, mimeType) {
  const response = await getImageBlob(id);
  if (response) return;
  if (!response) {
    const blob = base64ToBlob(base64, mimeType);
    await storeImageBlob(id, blob);
  }
}

// Função para armazenar o Blob no IndexedDB
export const storeImageBlob = async (id, blob) => {
  try {
    const db = await openImageDB();
    await db.put('blobs', { id, blob });
  } catch (error) {
    console.error('Erro ao armazenar Blob:', error);
  }
};

// Função para recuperar o Blob do IndexedDB
export const getImageBlob = async (id) => {
  try {
    const db = await openImageDB();
    const data = await db.get('blobs', id);
    return data ? URL.createObjectURL(data.blob) : null;
  } catch (error) {
    console.error('Erro ao recuperar Blob:', error);
    return null;
  }
};


export const deleteAllCacheFiles = async () => {
  try {
    const db = await openImageDB();
    const tx = db.transaction('blobs', 'readwrite');
    const store = tx.objectStore('blobs');
    await store.clear(); // Limpa todas as entradas do objectStore
    await tx.done;
    console.log('Todas as imagens foram deletadas do IndexedDB.');
  } catch (error) {
    console.error('Erro ao deletar as imagens do IndexedDB:', error);
  }
};



export const downloadMediaAndSaveCache = async (message, chat) => {
  console.log('chat', chat)

  // 1. Baixar a mídia
  // 2. Salvar a mídia no IndexedDB
  let querys = `?sessao=${chat.sessao}&msgId=${message.id}&canal=whatsapp`
  const response = await v1_actionDownloadMediaWhatsapp(querys);

  if (response.status === 200) {
    let number = soNumeros(message.chatId);
    if (chat.numeroCliente === number) {
      initCacheFileSave(message.id, `data:image/jpeg;base64, ${response.data.data.base64}`, message.mimetype);
    }
  }



}